var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.modalShow ? _c('modal', {
    attrs: {
      "large": true,
      "element_list": _vm.modal_info,
      "tab_form": true,
      "tab_values": _vm.elements,
      "tabs": _vm.tabs
    },
    on: {
      "close": _vm.close,
      "save_settings": _vm.save_settings
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }